import {CategoryProps, translatedCategoryProps} from 'modules/categories/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface SubCategoryProps {
  id: string;
  name: string;
  active: boolean;
  category: CategoryProps;
  image?: string;
}

export const translatedSubCategoryProps: TranslatedKeys<SubCategoryProps> = {
  name: 'Nome',
  active: 'Ativo?',
  category: {...translatedCategoryProps, name: 'Categoria'},
  image: 'Imagem',
};
